const settings = {
    hideWorkspacesCreateWorkspaceButton: process.env.REACT_APP_HIDE_WORKSPACES_CREATE_WORKSPACE_BUTTON == "true",
};

export {
    settings,
}
